<div class="card card-stats">

    <div class="card-header card-header-success card-header-icon">
        <div class="card-icon">
            <i class="material-icons">pending_actions</i>
        </div>
        <h2 class="card-title">Estimación de tiempo</h2>
    </div>

    <div class="card-body cero-padding-bottom">
        <form>
            <div class="row">

                <div class="col-6 text-center border-tarea">
                    <h2>Tiempo estimado</h2>
                </div>

                <div class="col-6">
                    <section class="text-center">
                        <mat-checkbox [(ngModel)]="esPausaConsiderada"
                                      [ngModelOptions]="{ standalone: true }"
                                      (change)="considerarPausa()">
                            Agregar una pausa al tiempo estimado
                            <mat-icon [matTooltipPosition]="'above'"
                                      matTooltip='Indique la hora y duración de la pausa automática'>
                                help_outline
                            </mat-icon>
                        </mat-checkbox>
                    </section>
                </div>

                <div class="col-6 center-element border-tarea">
                    <table>
                        <tr>
                            <td>
                                <mat-form-field [formGroup]="formGroup"
                                                class="large-font bold-font time-input hours-input">
                                    <input matInput autocomplete="off" type="number"
                                           formControlName="horasTareaFormControl"
                                           [errorStateMatcher]="matcher" aria-label="Horas">
                                    <mat-hint class="hours-input">Horas</mat-hint>
                                    <mat-error *ngIf="formGroup.get('horasTareaFormControl').errors
                                            && !formGroup.get('horasTareaFormControl').hasError('required')">
                                        Inválido
                                    </mat-error>
                                </mat-form-field>
                            </td>
                            <td class="large-font bold-font">
                                <div class="mb-2">
                                    <b>:</b>
                                </div>
                            </td>
                            <td>
                                <mat-form-field [formGroup]="formGroup" class="large-font bold-font time-input">
                                    <input matInput autocomplete="off" type="number"
                                           formControlName="minutosTareaFormControl"
                                           (input)="agregarCerosInicialesMinutosTarea()"
                                           [errorStateMatcher]="matcher" aria-label="Minutos">
                                    <mat-hint class="hours-input">Minutos</mat-hint>
                                    <mat-error *ngIf="formGroup.get('minutosTareaFormControl').errors
                                            && !formGroup.get('minutosTareaFormControl').hasError('required')">
                                        Inválido
                                    </mat-error>
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" class="text-center">
                                <mat-error *ngIf="formGroup.get('horasTareaFormControl').hasError('required')
                                    || formGroup.get('minutosTareaFormControl').hasError('required')">
                                    <strong> Datos requeridos </strong>
                                </mat-error>
                            </td>
                        </tr>
                    </table>
                </div>

                <div class="col-3 center-element">
                    <mat-form-field [formGroup]="formGroup" class="large-font bold-font pausa-time-input">
                        <input matInput autocomplete="off" type="time"
                               formControlName="inicioPausaFormControl"
                               (ngModelChange)="validarHoraPausa()"
                               [errorStateMatcher]="matcher" aria-label="Hora de la pausa">
                        <mat-hint class="hours-input">Hora de la pausa</mat-hint>
                        <mat-error *ngIf="formGroup.get('inicioPausaFormControl').errors">
                            Hora inválida
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-3 center-element">
                    <table>
                        <tr>
                            <td>
                                <mat-form-field [formGroup]="formGroup"
                                                class="large-font bold-font time-input hours-input">
                                    <input matInput autocomplete="off" type="number"
                                           formControlName="horasPausaFormControl"
                                           (input)="validarHoraPausa()"
                                           [errorStateMatcher]="matcher" aria-label="Horas">
                                    <mat-hint class="hours-input">Horas</mat-hint>
                                    <mat-error *ngIf="formGroup.get('horasPausaFormControl').errors
                                            && !formGroup.get('horasPausaFormControl').hasError('required')">
                                        Inválido
                                    </mat-error>
                                </mat-form-field>
                            </td>
                            <td class="large-font bold-font">
                                <div class="mb-2">
                                    <b>:</b>
                                </div>
                            </td>
                            <td>
                                <mat-form-field [formGroup]="formGroup" class="large-font bold-font time-input">
                                    <input matInput autocomplete="off" type="number"
                                           formControlName="minutosPausaFormControl"
                                           (input)="agregarCerosInicialesMinutosPausa()"
                                           [errorStateMatcher]="matcher" aria-label="Minutos">
                                    <mat-hint class="hours-input">Minutos</mat-hint>
                                    <mat-error *ngIf="formGroup.get('minutosPausaFormControl').errors
                                            && !formGroup.get('minutosPausaFormControl').hasError('required')">
                                        Inválido
                                    </mat-error>
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" class="text-center">
                                <mat-error *ngIf="formGroup.get('horasPausaFormControl').hasError('required')
                                    || formGroup.get('minutosPausaFormControl').hasError('required')">
                                    <strong> Datos requeridos </strong>
                                </mat-error>
                            </td>
                        </tr>
                    </table>
                </div>

                <div class="col-6 center-element large-font border-tarea">
                    <div class="row mt-4">
                        <div class="col-md-6 col-sm-6">
                            <div class="text-center text-nowrap">
                                <b>Hora inicio</b> <br> {{ relojInicioTarea | date: 'hh:mm a' }}
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="text-center text-nowrap">
                                <b>Hora termino</b> <br> {{ relojFinTarea | date: 'hh:mm a' }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-6 mt-4 center-element">
                    <div class="row">
                        <div class="col-md-12 col-sm-12">
                            <div class="text-center">
                                <b class="large-font">{{ tarea.nombre }}</b>
                                <br>
                                {{ tarea.descripcion }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 mt-4 pull-left">
                    <label>
                        <strong>*</strong>
                        Interactuar de forma manual con esta u otra tarea
                        <strong>anulará</strong> la programación de las tareas
                    </label>
                </div>

            </div>
        </form>
    </div>

    <div class="card-footer">
        <button mat-raised-button class="btn btn-sm btn-info mb-2 mr-2" (click)="cerrarModal()">
            <mat-icon>clear</mat-icon>
            Cancelar
        </button>
        <div class="pull-right">
            <button mat-raised-button class="btn btn-sm btn-warning mb-2 mr-2" (click)="iniciarTareaLibremente()">
                <mat-icon>done</mat-icon>
                Iniciar libremente
            </button>
            <button mat-raised-button class="btn btn-sm btn-success mb-2"
                    [disabled]="formGroup.invalid"
                    (click)="validarInicioTarea()">
                <mat-icon>event_available</mat-icon>
                Iniciar programado
            </button>
        </div>
    </div>

</div>
